import JassEventId from './eventid';

/**
 * type gameevent
 */
export default class JassGameEvent extends JassEventId {}
